export default __webpack_public_path__ + "static/media/symptop1.9ac70350.png";